import request from '@/utils/request'

// 导入用户
let PointsApplyApi = {

  /*列表*/
  getList(data, errorback) {
    return request._post('/shop/user.points_apply/index', data, errorback);
  },

  /*添加*/
  add(data, errorback) {
    return request._post('/shop/user.points_apply/add', data, errorback);
  },

  /*删除*/
  del(data, errorback) {
    return request._post('/shop/user.points_apply/del', data, errorback);
  },

  /*编辑*/
  edit(data, errorback) {
    return request._post('/shop/user.points_apply/edit', data, errorback);
  },

  /*审核*/
  audit(data, errorback) {
    return request._post('/shop/user.points_apply/audit', data, errorback);
  },
}

export default PointsApplyApi;



// WEBPACK FOOTER //
// ./src/api/study/points_apply.js